import { Injectable } from '@angular/core';
import { InterfaceAccessMatrix, InterfacePermissionsMatrix } from '../../modules/login/interfaces/login.interface';
import { IMenuItem } from '../layout/side-menu/interfaces/MenuItem.interface';
import { BehaviorSubject } from 'rxjs';
import { DEFAULT_LANG } from '@components/timeline/constants/constants';
/**
 * Урл по которому перейдем в случае если на отправило на логинку
 * @type {string}
 */
const RESTORE_URL = 'Restore_Url';
/**
 * Токен авторизации
 * @type {string}
 */
const TOKEN_KEY = 'AuthToken';
/**
 * Карта ролей
 * @type {string}
 */
const ROLE_ACCESS = 'AuthRoleAccess';
/**
 * Матрица доступа
 * @type {string}
 */
const ACCESS_MATRIX = 'AuthAccessMatrix';
/**
 * Структура меню
 * @type {string}
 */
const STRUCTURE_MENU = 'StructureMenu';
/**
 * Текущий язык
 * @type {string}
 */
export const CURRENT_LANG = 'CurrentLang';
/**
 * Восстановление пароля
 * @type {string}
 */
const RECOVERY = 'Recovery';
/**
 * Сохраненные поиски таблиц
 * @type {string}
 */
const FILTER_TABLE = 'FilterTables';
/**
 * Сохраненные скроллы таблиц
 * @type {string}
 */
const SCROLL_TABLE = 'ScrollTables';
/** Флаг отображения капчи */
const IS_SHOW_CAPTCHA = 'isShowCaptcha';

/**
 * Класс работы с токеном авторизации
 */
@Injectable()
export class TokenStorage {
    /**
     * Конструктор
     */
    constructor() {}

    /**
     * Матрица доступа
     */
    private accessMatrix = new BehaviorSubject<InterfaceAccessMatrix>(null);

    /**
     * Наблюдаемый объект матрицы доступа
     */
    accessMatrix$ = this.accessMatrix.asObservable();

    /**
     * Матрица ролевого доступ
     */
    private roleAccess = new BehaviorSubject<InterfacePermissionsMatrix>(null);

    /**
     * Наблюдаемый объект матрицы ролевого доступа
     */
    roleAccess$ = this.roleAccess.asObservable();

    /**
     * Список меню
     */
    private menu = new BehaviorSubject<IMenuItem[]>([]);

    /**
     * Наблюдаемый объект списка меню
     */
    menu$ = this.menu.asObservable();

    /**
     * Текущий язык
     */
    private currentLanguage = new BehaviorSubject<string>(DEFAULT_LANG);

    /**
     * Наблюдаемый объект текущего языка
     */
    currentLanguage$ = this.currentLanguage.asObservable();

    /**
     * Токен
     */
    private token = new BehaviorSubject<string>('');

    /**
     * Наблюдаемый объект токена
     */
    token$ = this.token.asObservable();

    /**
     * Выход из системы
     */
    signOut() {
        window.localStorage.removeItem(TOKEN_KEY);
        window.localStorage.clear();

        this.token.next('');
    }

    /**
     * Сохранение токена
     * @param {string} token токен
     */
    public saveToken(token: string) {
        window.localStorage.removeItem(TOKEN_KEY);
        window.localStorage.setItem(TOKEN_KEY, token);

        this.token.next(token);
    }

    /**
     * Получение токена
     * @returns {string}
     */
    public getToken(): string {
        const token = localStorage.getItem(TOKEN_KEY);
        this.token.next(token);

        return token;
    }

    /**
     * Сохранение карты ролей
     * @param {InterfacePermissionsMatrix} roleAccess токен
     */
    public saveRoleAccess(roleAccess: InterfacePermissionsMatrix) {
        window.localStorage.removeItem(ROLE_ACCESS);
        window.localStorage.setItem(ROLE_ACCESS, JSON.stringify(roleAccess));

        this.roleAccess.next(roleAccess);
    }

    /**
     * Получение карты ролей
     * @returns {object}
     */
    public getRoleAccess(): InterfacePermissionsMatrix {
        const roleAccess = JSON.parse(localStorage.getItem(ROLE_ACCESS));
        this.roleAccess.next(roleAccess);

        return roleAccess;
    }

    /**
     * Сохранение матрицы доступа
     * @param accessMatrix матрица доступов
     */
    public saveAccessMatrix(accessMatrix: InterfaceAccessMatrix) {
        window.localStorage.removeItem(ACCESS_MATRIX);
        window.localStorage.setItem(ACCESS_MATRIX, JSON.stringify(accessMatrix));

        this.accessMatrix.next(accessMatrix);
    }

    /**
     * Получение меню
     * @returns {object}
     */
    public getMenu(): IMenuItem[] {
        const menu = JSON.parse(localStorage.getItem(STRUCTURE_MENU));
        this.menu.next(menu);

        return menu;
    }

    /**
     * Сохранение структуры меню
     * @param menu структура меню
     */
    public saveMenu(menu: IMenuItem[]) {
        window.localStorage.removeItem(STRUCTURE_MENU);
        window.localStorage.setItem(STRUCTURE_MENU, JSON.stringify(menu));

        this.menu.next(menu);
    }

    /**
     * Получение матрицы доступа
     * @returns any
     */
    public getAccessMatrix(): InterfaceAccessMatrix {
        const accessMatrix = JSON.parse(localStorage.getItem(ACCESS_MATRIX));
        this.accessMatrix.next(accessMatrix);

        return accessMatrix;
    }

    /**
     * Сохранение текущего языка
     * @param {string} lang язык
     */
    public saveCurrentLang(lang: string) {
        window.sessionStorage.removeItem(CURRENT_LANG);
        window.sessionStorage.setItem(CURRENT_LANG, lang);

        this.currentLanguage.next(lang);
    }

    /**
     * Получение текущего языка
     * @returns {object}
     */
    public getCurrentLang(): string {
        const lang = window.sessionStorage.getItem(CURRENT_LANG);
        this.currentLanguage.next(lang);

        return lang;
    }

    /**
     * Сохранение данных восстановления пароля
     * @param data данные
     */
    public saveRecovery(data: { datetime: Date; phone: string }) {
        window.localStorage.removeItem(RECOVERY);
        window.localStorage.setItem(RECOVERY, JSON.stringify(data));
    }

    /**
     * Получение данных восстановления пароля
     */
    public getRecovery(): { datetime: Date; phone: string } {
        const data = localStorage.getItem(RECOVERY);
        return data ? JSON.parse(data) : null;
    }

    /**
     * Сохранение данных фильтрации таблицы
     * @param key ключ
     * @param data данные
     */
    public saveFilterTable(key: string, data: { [key: string]: any }) {
        let dataFilter: any = localStorage.getItem(FILTER_TABLE);
        if (!dataFilter) {
            dataFilter = {};
        } else {
            dataFilter = JSON.parse(dataFilter);
        }
        dataFilter[key] = data;
        window.localStorage.removeItem(FILTER_TABLE);
        window.localStorage.setItem(FILTER_TABLE, JSON.stringify(dataFilter));
    }

    /**
     * Получение данных фильтрации таблицы
     */
    public getFilterTable(key: string): any {
        let data = localStorage.getItem(FILTER_TABLE);
        if (data) {
            data = JSON.parse(data);
        }
        return data && data[key] ? data[key] : null;
    }

    /**
     * Сохранение данных скролла таблицы
     * @param key ключ
     * @param data данные
     */
    public saveScrollTable(key: string, data: number) {
        let dataScroll: any = window.sessionStorage.getItem(SCROLL_TABLE);
        if (!dataScroll) {
            dataScroll = {};
        } else {
            dataScroll = JSON.parse(dataScroll);
        }
        dataScroll[key] = data;
        window.sessionStorage.removeItem(SCROLL_TABLE);
        window.sessionStorage.setItem(SCROLL_TABLE, JSON.stringify(dataScroll));
    }

    /**
     * Получение данных скролла таблицы
     */
    public getScrollTable(key: string): number {
        let data = window.sessionStorage.getItem(SCROLL_TABLE);
        if (data) {
            data = JSON.parse(data);
        }
        return data && data[key] ? data[key] : null;
    }

    setRestoreUrl(url: string): void {
        window.localStorage.setItem(RESTORE_URL, url);
    }

    getRestoreUrl(): string {
        return window.localStorage.getItem(RESTORE_URL);
    }

    removeRestoreUrl(): void {
        window.localStorage.removeItem(RESTORE_URL);
    }

    /** Проверка на отображения Captcha */
    public isShowCaptcha(): boolean {
        return Number(window.localStorage.getItem(IS_SHOW_CAPTCHA)) === 1;
    }

    /** Установить параметр для проверки Captcha */
    public setIsShowCaptcha(flag: boolean): void {
        window.localStorage.setItem(IS_SHOW_CAPTCHA, flag ? '1' : '0');
    }
}
